export default {
  errorTitle: 'Ressource introuvable',
  fetchError: 'Échec du chargement de la ressource',
  resourceNotFound: 'La ressource demandée n\'a pas pu être trouvée',
  available: 'Disponible',
  outOfStock: 'En rupture de stock',
  borrowed: 'Emprunté',
  previousImage: 'Image précédente',
  nextImage: 'Image suivante',
  noImage: 'Aucune image disponible',
  description: 'Description',
  details: 'Détails',
  sku: 'SKU',
  quantity: 'Quantité',
  category: 'Catégorie',
  owner: 'Propriétaire',
  personalResource: 'Ressource Personnelle',
  location: 'Localisation',
  notes: 'Notes',
  currentStock: 'Stock actuel',
  brand: 'Marque',
  weight: 'Poids',
  dimensions: 'Dimensions',
  createdAt: 'Créé le',
  updatedAt: 'Modifié le',
  tags: 'Étiquettes',
  // New fields
  units_available: 'unités disponibles',
  needs_refill: 'Besoin de réapprovisionnement',
  borrowed_by: 'Emprunté par',
  unknown_user: 'Utilisateur inconnu',
  ready_to_borrow: 'Prêt à emprunter',
  initial: 'initial',
  type: 'Type',
  consumable: 'Consommable',
  borrowable: 'Empruntable',
  // Actions
  borrow: 'Emprunter',
  return: 'Retourner',
  consume: 'Consommer',
  refill: 'Réapprovisionner',
  reserve: 'Réserver',
  // Transaction History
  transactionHistory: 'Historique des transactions',
  noTransactions: 'Aucune transaction trouvée pour cette ressource.',
  transactionsLoadError: 'Échec du chargement de l\'historique des transactions.',
  units: 'unités',
  transactions: {
    borrowed: 'Emprunté',
    returned: 'Retourné',
    consumed: 'Consommé',
    refilled: 'Réapprovisionné',
    reserved: 'Réservé',
    returnedOn: 'retourné le',
    borrowings: 'Emprunts',
    consumptions: 'Consommations',
    refills: 'Réapprovisionnements',
    overview: 'Vue d\'ensemble',
    borrowingHistory: 'Historique des emprunts',
    actualBorrowing: 'Emprunt réel',
    reservation: 'Réservation',
    borrowingsAndReservations: 'Emprunts et réservations'
  }
};
